import { render, staticRenderFns } from "./new_purchase.vue?vue&type=template&id=06e22cc3"
import script from "./new_purchase.vue?vue&type=script&lang=js"
export * from "./new_purchase.vue?vue&type=script&lang=js"
import style0 from "./new_purchase.vue?vue&type=style&index=0&id=06e22cc3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports